
import { axiosWithAuth } from '../../utils/useAxiosAuth';

export const BEGIN_UPDATE_USER = 'BEGIN_UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const updateUser = (id, user) => dispatch => {
    dispatch({type: BEGIN_UPDATE_USER});

    axiosWithAuth()
    .put(`/auth/users/${id}`, {
        'name': user.name,
        'email': user.email,
        'password': user.password
    })
    .then(res => {
        dispatch({ type: UPDATE_USER_SUCCESS, payload: res.data, message: 'successfully updated user'})
    })
    .catch(error => {
        console.log(error);

        dispatch({type: UPDATE_USER_FAILURE, payload: error.response.data.message})
    });
}


export const BEGIN_DELETE_USER = 'BEGIN_DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const deleteUser = (id) => dispatch => {
    dispatch({type: BEGIN_DELETE_USER })

    axiosWithAuth()
    .delete(`/auth/users/${id}`)
    .then(res => {
      dispatch({ type: DELETE_USER_SUCCESS, payload: id })
    })
    .catch(error => {
        console.error(error);
        dispatch({ type: DELETE_USER_FAILURE, payload: error.response.data.message})
    });
}